import * as React from "react";
import { NavLink } from "react-router-dom";
import useBreadcrumbs from "use-react-router-breadcrumbs";

const BreadCrumbs = ({routes}: any) => {
  const breadcrumbs = useBreadcrumbs(routes, { excludePaths: ["/"], disableDefaults: true });

  return (
    <>
      {breadcrumbs.map(({ match, breadcrumb }, index) => (
        <React.Fragment key={match.url}>
          {index !==
            (breadcrumbs.length - 1) ? (
              <span className="text-xs font-semibold text-gray-700">
                <NavLink to={match.url}>{breadcrumb}</NavLink>
              </span>
            ) : (
              <span className="text-sm text-dark-blue">{breadcrumb}</span>
            )}

          {index !== breadcrumbs.length - 1 && <span className="mx-2">/</span>}
        </React.Fragment>
      ))}
    </>
  );
};

export default BreadCrumbs;
